<template>
    <div class="api-info">
        <h4>API</h4>

        <div class="info-row">
            <span class="info-label">Endpoint:</span>
            <code class="endpoint-url">{{ endpointUrl }}</code>
        </div>

        <div class="info-row">
            <span class="info-label">Token:</span>
            <span class="token-value">{{ showToken ? apiKey : maskedToken }}</span>
            <PrimeButton
                :icon="showToken ? 'pi pi-eye-slash' : 'pi pi-eye'"
                class="p-button-sm p-button-text"
                @click="showToken = !showToken"
            />
            <PrimeButton
                icon="pi pi-copy"
                class="p-button-sm p-button-text"
                @click="copyEndpoint"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "ApiInfo",
    props: {
        projectId: {
            type: Number,
            required: true
        },
        apiKey: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showToken: false
        };
    },
    computed: {
        endpointUrl() {
            return `https://gramotacafe.ru/user_api/v1/createDoc/${this.projectId}?token=${this.apiKey}`;
        },
        maskedToken() {
            if (!this.apiKey) return '********';
            return this.apiKey.substring(0, 4) + '****' + this.apiKey.substring(this.apiKey.length - 4);
        }
    },
    methods: {
        copyEndpoint() {
            navigator.clipboard.writeText(this.endpointUrl).then(() => {
                this.$toast.add({
                    severity: 'success',
                    summary: 'Скопировано',
                    detail: 'Endpoint скопирован в буфер обмена',
                    life: 2000
                });
            });
        }
    }
}
</script>

<style scoped>
.api-info {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 24px;
}

h4 {
    margin-bottom: 16px;
}

.info-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.info-label {
    font-weight: 500;
    min-width: 80px;
    color: #6c757d;
}

.endpoint-url {
    font-family: monospace;
    background: #e9ecef;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.85rem;
    word-break: break-all;
}

.token-value {
    font-family: monospace;
    background: #e9ecef;
    padding: 4px 8px;
    border-radius: 4px;
}
</style>
